import { render, staticRenderFns } from "./WireCardAccount.vue?vue&type=template&id=1d3052f9"
import script from "./WireCardAccount.vue?vue&type=script&lang=js"
export * from "./WireCardAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports